import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { BazisFormModule } from '@bazis/form/form.module';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { TooltipModule } from '@bazis/shared/components/web/tooltip/tooltip.module';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'app-map-search-control',
    templateUrl: 'search.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        BazisFormModule,
        CommonModule,
        TranslocoModule,
        ButtonModule,
        IconModule,
        TooltipModule,
        ReactiveFormsModule,
    ]
})
export class MapSearchComponent {
    @Input() isOpen = false;

    searchControl = new FormControl<string | null>('');

    clearAndClose() {
        this.searchControl.setValue('');
        this.isOpen = false;
    }
}
